import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {DefaultMeshCellSettings} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshCellSettings';
import {CellSettingsSubMenu} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/header/cellSettingsBar/CellSettingsSubMenu';
import {FontSizeInput} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/header/cellSettingsBar/FontSizeInput';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';
import bind from 'bind-decorator';

import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./FontSize.less');
const cx = classnames.bind(styles);

export interface IFontSizeProps
{
    focusedSheetId:SheetId;

    selected:number;
    onChange:(fontSize:number, closePopover?:boolean) => void;

    onShow:() => void;
    onHide:() => void;

    isSelected:boolean
}

export interface IFontSizeState
{
}

const fixedSizes:Array<number> = [6, 7, 8, 9, 10, 11, 12, 14, 18, 24, 36];

export class FontSize extends React.Component<IFontSizeProps, IFontSizeState>
{
    private _inputElement:HTMLInputElement = null;

    public render()
    {
        const {focusedSheetId, selected, isSelected} = this.props;

        return (
            <div>

                <FontSizeInput
                    value={selected}
                    isSelected={isSelected}
                    onChange={this._onChange}
                    data={fixedSizes}
                    selected={selected}
                    onRef={this._onInputElementRef}
                />

                <CellSettingsSubMenu
                    focusedSheetId={focusedSheetId}
                    className={cx('base')}
                    onShow={this._onShowSubmenu}
                    onHide={this._onHide}
                >
                    {fixedSizes.map((fontSize:number) =>
                    {
                        const isSelected = fontSize === selected;

                        return (
                            <div
                                key={fontSize}
                                className={cx('item', {isSelected})}
                                onClick={() => this._onChange(fontSize, true)}
                            >
                                <div className={cx('menuItemIcon')}>
                                    {
                                        isSelected &&
                                        <MDIcon
                                            name={MDIcons.common.Checkmark}
                                            size={MDIconSize.medium16}
                                            className={cx('icon')}
                                        />
                                    }
                                </div>
                                {fontSize}
                            </div>
                        );
                    })}

                </CellSettingsSubMenu>

            </div>
        );
    }

    @bind
    private _onShowSubmenu():void
    {
        const {onShow} = this.props;

        setTimeout(() =>
        {
            this._inputElement.focus();
            this._inputElement.select();
        }, 0);

        onShow && onShow();
    }

    @bind
    private _onChange(fontSize:number, closePopover:boolean = true):void
    {
        if( closePopover && this._checkFontSizeAndOnChange(fontSize, closePopover) ) return;

        const {onChange} = this.props;

        onChange && onChange(fontSize, closePopover);
    }

    @bind
    private _onInputElementRef(element:HTMLInputElement):void
    {
        if( !element )
            return;

        this._inputElement = element;
    }

    @bind
    private _onHide():void
    {
        const {onHide} = this.props;

        let fontSize = parseInt(this._inputElement.value);

        this._checkFontSizeAndOnChange(fontSize, false);

        onHide && onHide();
    }

    private _checkFontSizeAndOnChange(fontSize:number, closePopover:boolean = true):boolean
    {
        const {onChange} = this.props;

        if( !onChange ) return;

        if( !fontSize )
        {
            onChange(DefaultMeshCellSettings.fontSize, closePopover);
            return true;
        }

        if( fontSize > DefaultMeshCellSettings.fontSizeMax )
        {
            onChange(DefaultMeshCellSettings.fontSizeMax, closePopover);
            return true;
        }

        if( fontSize < DefaultMeshCellSettings.fontSizeMin )
        {
            onChange(DefaultMeshCellSettings.fontSizeMin, closePopover);
            return true;
        }
    }

}
